import { render, staticRenderFns } from "./background-gradients.vue?vue&type=template&id=773a50a1&"
import script from "./background-gradients.vue?vue&type=script&lang=js&"
export * from "./background-gradients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports